import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";   // << FIXED
import logo from "../assets/logo.png";

export default function Navigation() {
  return (
    <nav className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <div className="inline-flex items-center justify-center backdrop-blur-sm m-3">
                <Link to="/" className="flex-shrink-0 flex items-center">
                  <img
                    src={logo}
                    alt="Valuatify Logo"
                    className="h-12 rounded-lg"
                  />
                </Link>
              </div>
            </div>

          </div>
        </div>
      </div>
    </nav>
  );
}
